import { List } from "./List";
import { SessionList } from "./SessionList";
import { SessionDetail } from "./SessionDetail";

/**
 * SuperChatLog 템플릿 모듈
 *
 * @description 채팅 로그 관련 템플릿들을 모아놓은 모듈
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-16
 */
export default { List, SessionList, SessionDetail };
